<template>
  <div>
    <!-- div class="title-and-search">
      <div class="row">
        <div class="blocheader-wrapper single-title-wrapper col-12">
          <div class="row">
            <div class="title-box col-3 clear-side-padding">
              <h1>TEMPLATES - FICHES D'ESPACES</h1>
            </div>
            <div
              class="button-box col-9 clear-side-padding"
            >
            </div>
          </div>
        </div>
      </div>
    </div -->
    <div v-if="this.pending()" class="row">
      <loading></loading>
    </div>
    <div v-else-if="!this.pending() && this.templateData" class="row">
      <div class="col-3">
        <liste-template
          :tableau-details="this.ficheTableauData()"
          :template-data="this.templateData"
        />
      </div>
      <div class="col-9">
        <loading v-if="this.loading()"></loading>
        <ficheEspaceContent
          style="height: calc(100vh - 100px); overflow-y: auto;"
          v-else-if="!this.loading() && this.ficheData"
          :fiche="this.ficheData"
        ></ficheEspaceContent>
      </div>
    </div>
  </div>
</template>

<script>

import listeTemplate from '../../components/ficheEspace/template/listeTemplate'
import ficheEspaceContent from '../../components/ficheEspace/ficheEspaceContent'
import { mapActions, mapGetters } from 'vuex'
import loading from '../../components/loading'

export default {
  components: {
    listeTemplate,
    ficheEspaceContent,
    loading
  },
  data () {
    return {
      templateData: null,
      ficheData: null
    }
  },
  methods: {
    ...mapActions(['setCurrentProject', 'getFicheTableauData', 'getAllTemplatesFiche', 'loadTemplateData', 'setLoading', 'setPending', 'setCurrentFiche', 'setLastFiche']),
    ...mapGetters(['currentProject', 'tableauSurfaceList', 'isLoadingTableauData', 'isFicheLoaded', 'currentFicheData', 'isLoadingFicheData', 'isLoadingTemplatesFiche', 'ficheTableauData', 'loading', 'pending', 'lastFiche'])
  },
  computed: {
    ...mapGetters(['templatesFiche', 'currentFiche'])
  },
  watch: {
    templatesFiche: {
      handler (newValue) {
        this.templateData = { ...newValue }
      },
      deep: true
    },
    async currentFiche (newValue, oldValue) {
      if (newValue != null) {
        try {
          this.setLoading(true)
          this.ficheData = null
          await this.loadTemplateData(newValue)
          this.ficheData = this.currentFicheData()
        } catch (e) {
        } finally {
          this.setLoading(false)
        }
      }
    }
  },
  async created () {
    const idProject = this.$route.params.idProject
    this.setPending(true)
    await this.getFicheTableauData(idProject)
    await this.getAllTemplatesFiche(this.ficheTableauData().map(el => el.id))
    this.setCurrentFiche(null)
    if (this.lastFiche() != null) {
      this.setCurrentFiche(this.lastFiche())
      this.setLastFiche(null)
    }
    this.setPending(false)
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/pageTemplateFiche/index.vue